import { api } from '@/api'
import type { AdminItem } from '@/api/typings/admins.typing.ts'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export function getAdminsAction(page: number = 1): Promise<ApiPaginationResponse<AdminItem[]>> {
  return api.get<ApiPaginationResponse<AdminItem[]>>(`/admins?page=${page}`)
}
